import { render, staticRenderFns } from "./XTextArea.vue?vue&type=template&id=433d4927"
import script from "./XTextArea.vue?vue&type=script&lang=js"
export * from "./XTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports